export function ModalCloseBunpimaySVG({ width, height, viewBox }) {
	return (
		<svg
			width={width}
			height={height}
			viewBox={viewBox}
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M3 3L29 29M29 3L3 29" stroke="white" stroke-width="7" />
		</svg>
	)
}
